import actions from './attestations/actions';
import getters from './attestations/getters';
import mutations from './attestations/mutations';

const state = {
  actionableStatuses: {
    B: ['Pending Review'],
    C: ['Pending Client'],
    T: ['Pending Review'],
  },
  attestationDetail: [],
  attestationHistory: [],
  attestationHistoryDetail: [],
  attestations: [],
  attestationsLoading: false,
  attestationConfirmationsPending: 0,
  attestationRequestsPending: 0,
  attestationPollingHandle: null,
  internalApprovals: [],
  internalApprovalsLoading: false,
  internalDetail: [],
  pendingConfirmations: [],
  currentConfirmations: [],
  clientApprovalListLoading: true,
  clientApprovalList: [],
  clientApprovalListMessage: '',

  clientApprovalDetailLoading: true,
  clientApprovalDetail: [],
  clientApprovalDetailMessage: '',
  
}

export const attestations = {
  namespaced: false,
  state,
  actions,
  getters,
  mutations,
}
